import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const CategoryName = ({ form, disabled, categoriesTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Категория:</span>
      <Form.Item>
        {getFieldDecorator('category', {
          rules: [{
            required: true,
            message: "Поле, обязательно для заполнения"
          }]
        })(
          <Select
            placeholder="XX"
            className="smallInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {categoriesTypes &&
              categoriesTypes.map((category, index) => (
                <Select.Option
                  value={category.vehicleCategoryId}
                  key={category.vehicleCategoryId}
                >
                  {category.categoryName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(CategoryName, ['categoriesTypes']);
